import React from "react";
import { Link } from "react-router-dom";
import Section from "./Section";
import SectionHeading from "./SectionHeading";
import PriceCard from "./PriceCard";

/**
 * Per design-system/landing.md §6: "cheapest in category" is a claim backed
 * by real research (Codacy $18, CodeRabbit $24-30, Graphite $20-40), but the
 * named comparison belongs on /pricing (sub-task D), not this preview — same
 * reasoning as cutting the GitHub comparison table: don't put a claim in
 * front of every visitor that needs a citation to back it up on the same
 * screen. The badge here is a teaser; /pricing does the substantiating.
 */
export default function PricingPreview() {
  return (
    <Section id="pricing" variant="elevated">
      {/*
        Heading history, because this line has now been wrong twice in
        different directions:
          1. "One plan. No surprises." — sat above a two-tier Free/Pro card
             and contradicted it.
          2. "Free to start. One flat price to grow." — matched /pricing's
             heading, but this section renders a bare <PriceCard /> which
             defaults to tier="pro". So the heading promised a Free tier
             that had no card beneath it on this page.

        Now carries the closing line that used to live in a separate
        FinalCta section directly below (deleted 2026-08-31). That section
        repeated this card's CTA label, its destination, AND its trial
        microcopy verbatim, while sharing the same `elevated` background —
        so the two rendered as one section that said the same thing twice.
        Folding the headline up here keeps the strongest copy on the page
        and makes pricing the single close.

        The Free tier is now stated in the lead rather than implied by a
        card that isn't rendered; the link below does the comparing.
      */}
      <SectionHeading
        eyebrow="Pricing"
        title="Stop reviewing pull requests in the order they arrived."
        lead="Free for one repo and up to five people. $99/month flat when you outgrow it — unlimited repos, unlimited members, however large the team gets."
      />
      <div className="mt-12 flex flex-col items-center gap-6">
        <PriceCard />
        <Link
          to="/pricing"
          className="cursor-pointer text-sm font-medium text-rf-accent-blue transition-colors duration-200 hover:text-rf-text-primary"
        >
          Compare both plans & read the FAQ →
        </Link>
      </div>
    </Section>
  );
}
